'use strict';

load_script('/js/src/app/ui/glossary.js');
load_script('/js/src/app/ui/glossary-term.js');
load_script('/js/src/app/ui/knowledge_check.js');

function load_script(__src) {
    var __script = null;

    if (__src) {
        __script = document.createElement('script');

        __script.setAttribute('src', __src);
        if (document.getElementsByTagName('body')[0].appendChild(__script)) {
            return true;
        }
    }

    return false;
}
